module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAAHhSr/lAAAAAXNSR0IArs4c6QAAALlJREFUSA3NlsENgCAQBMVQmhZBKdbl1ypswjKQ+IR5XC5LPH9suHX2TohpO866dE9q60HMtQ7akiaUdzDfEoloI1LSRiTvN669QGsTm8nJBG9yMqWjMKSZ3kiFpJm6RYWkSclM3ScK0qRkcacpjSk1i/udSWNKzeKeAGlMqZn0bNJN4tWkKb0QVBcWLD/3RcC/a9K7TJkm7CjDguVSinICMq/Ufu/H/3uZvd8o7CjDguXW7N3f8HmVL7ojMg8W9uiVAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/Estonia.png
// module id = 503
// module chunks = 7